"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var react_redux_1 = require("react-redux");
var Task_1 = require("../component/Task");
var TasksMenu_1 = require("../component/TasksMenu");
var settings_1 = require("../redux/settings");
var tasks_1 = require("../redux/tasks");
var Items_1 = require("./Items");
var Timer_1 = require("./Timer");
var Tasks = /** @class */ (function (_super) {
    __extends(Tasks, _super);
    function Tasks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getItemsByTag = function (items) {
            var currentTag = _this.props.currentTag;
            switch (currentTag) {
                case null:
                    return items;
                case "":
                    return _.filter(items, function (_a) {
                        var tags = _a.tags;
                        return tags.length === 0;
                    });
            }
            return _.filter(items, function (_a) {
                var tags = _a.tags;
                return tags.includes(currentTag);
            });
        };
        return _this;
    }
    Tasks.prototype.render = function () {
        var _a = this.props, currentTag = _a.currentTag, doneItems = _a.doneItems, todoItems = _a.todoItems, timerOn = _a.timerOn;
        if (timerOn) {
            return React.createElement(Timer_1.default, null);
        }
        return (React.createElement(Items_1.default, __assign({ fixed: currentTag !== null, itemComponent: Task_1.default, menuComponent: TasksMenu_1.default }, this.props, { doneItems: this.getItemsByTag(doneItems), todoItems: this.getItemsByTag(todoItems) })));
    };
    Tasks.prototype.componentDidMount = function () {
        if (this.props.notificationOn === null) {
            this.props.requestNotificationPermission();
        }
    };
    return Tasks;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var settings = _a.settings, tasks = _a.tasks, timer = _a.timer;
    return (__assign({}, settings, tasks, { timerOn: timer.on }));
}, __assign({}, settings_1.actionCreators, tasks_1.actionCreators))(Tasks);



//////////////////
// WEBPACK FOOTER
// ./src/container/Tasks.tsx
// module id = 669
// module chunks = 0